// src/components/MobileBottomNav.js
import React, { useState, useEffect, useRef } from 'react';
import "styles/MobileBottomNav.css";

const menuContents = {
  talent: [
    'Discovery',
    'Portfolio',
    'MasterClass',
    'Awards',
    'Opportunities',
    'Projects'
  ],
  media: [
    'Updates',
    'Streaming',
    'Spotlight',
    'Podcast',
    'Blog'
  ],
  agency: [
    'Advertising & PR',
    'Marketing Packages',
    'Celebrity Campaigns',
    'Brand Ambassadors',
    'Digital Marketing',
    'Social Media Management',
    'Content Production',
    'Media Strategy',
    'Product Launch',
    'Promotional Events',
    'Event Management',
    'Training'
  ],
  community: [
    'FlourishTalents Club',
    'Membership Portal',
    'Community Outreach',
    'Patrons- Forum',
    'Exclusive Offers',
    'Merchandise',
    'Events',
    'Vacancies',
    'Partners',
  ]
};

export default function MobileBottomNav() {
  // ─── DROPDOWN STATE & REF ─────────────────────────────────────────────
  const [openMenu, setOpenMenu] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpenMenu(null);
      }
    }
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  // ─── BODY-DIM WHEN DROPDOWN OPEN ──────────────────────────────────────
  useEffect(() => {
    if (openMenu) document.body.classList.add('background-dim');
    else document.body.classList.remove('background-dim');
  }, [openMenu]);

  // ─── SCROLL-HIDE STATE ────────────────────────────────────────────────
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    let lastScrollY = window.scrollY;
    let ticking = false;

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const currentY = window.scrollY;
          const formOpen =
            document.getElementById('formContainer')?.style.display === 'block' ||
            document.getElementById('formContainerMobile')?.style.display === 'block';

          if (formOpen) {
            setHidden(true);
          } else {
            setHidden(currentY > lastScrollY);
            lastScrollY = currentY;
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // ─── RENDER ───────────────────────────────────────────────────────────
  return (
    <>
      <ul className={`mobile-bottom${hidden ? ' hide' : ''}`} data-cy="mobile-bottom">
        <li data-cy="mobile-nav-item">
          <a
            href="/"
            aria-current="page"
            className="mobile-bottom-item nuxt-link-exact-active nuxt-link-active"
          >
            <div className="icon-badge">
              <span className="icon is-normal small-grey-icon">
                <svg viewBox="0 0 24 24">
                  <path d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" />
                </svg>
              </span>
            </div>
            <span>Home</span>
          </a>
        </li>

        {['talent', 'media', 'agency', 'community'].map(menuKey => (
          <li
            key={menuKey}
            className="mobile-bottom-item mobile-dropdown-toggle"
            onClick={e => {
              e.stopPropagation();
              setOpenMenu(openMenu === menuKey ? null : menuKey);
            }}
          >
            <div className="icon-badge">
              <span className="icon is-normal small-grey-icon">
                <svg viewBox="0 0 24 24">
                  {menuKey === 'media' ? (
                    <path d="M4,4H7L9,2H15L17,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z" />
                  ) : menuKey === 'community' ? (
                    <path d="M16 17V19H2V17S2 13 9 13 16 17 16 17M12.5 7.5A3.5 3.5 0 1 0 9 11A3.5 3.5 0 0 0 12.5 7.5M15.94 13A5.32 5.32 0 0 1 18 17V19H22V17S22 13.37 15.94 13M15 4A3.39 3.39 0 0 0 13.07 4.59A5 5 0 0 1 13.07 10.41A3.39 3.39 0 0 0 15 11A3.5 3.5 0 0 0 15 4Z" />
                  ) : (
                    <path d="M7,10H12V15H7M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z" />
                  )}
                </svg>
              </span>
            </div>
            <span className="mobile-dropdown-text">
              {menuKey === 'agency'
                ? 'Agency'
                : menuKey === 'community'
                ? 'Community'
                : menuKey.charAt(0).toUpperCase() + menuKey.slice(1)}
            </span>
          </li>
        ))}
      </ul>

      <ul ref={dropdownRef} className={`mobile-dropdown-menu${openMenu ? ' open' : ''}`}>
        {openMenu &&
          menuContents[openMenu].map(item => (
            <li key={item}>
              <a href="#">{item}</a>
            </li>
          ))}
      </ul>
    </>
  );
}
